import { BaseParser } from 'app/services/api/parsers/base-parser';
import { ServerResponseData } from 'app/models/api/response';
import { Feedback } from 'app/models/api/feedback';
import { ParserMap } from 'app/services/api/parsers/response-parser';

export class FeedbackParser extends BaseParser {
    parse(data: ServerResponseData, included: ServerResponseData[], parsersMap: ParserMap) {
        const item = super.parseBase(Feedback, data);
        item.user = this.getRelationship('user', data, included, parsersMap);
        return item;
    }
}
